/**
 * @description
 * Константа для синхронизации transition-duration через css var
 */
export const TRANSITION_DURATION = 300;
export const INLINE_TRANSITION_DURATION = 100;

/**
 * @description
 * Константа для дефолтного значения maxHeight в дефолтном открытом состоянии
 */
export const EXPANDED_HEIGHT_DEFAULT = 9999;
export const DEFAULT_EXPAND_BUTTON_TEXT = 'Показать ещё';
export const DEFAULT_COLLAPSE_BUTTON_TEXT = 'Свернуть';
export const DEFAULT_TEST_ID = 'expander';
export const DEFAULT_LIST_TEST_ID = 'expander-list';
export const DEFAULT_TEXT_TEST_ID = 'expander-text';